(() => {
  const each = (selector, callback) => document.querySelectorAll(selector).forEach(callback);

  const sparkles = () => each('[data-sparkles]', (field, fieldIndex) => {
    if (field.dataset.ready) return;
    field.dataset.ready = '1';
    for (let i = 0; i < 12; i += 1) {
      const star = document.createElement('i');
      star.style.left = `${(i * 47 + fieldIndex * 29) % 100}%`;
      star.style.top = `${(i * 71 + fieldIndex * 43) % 100}%`;
      star.style.setProperty('--size', `${i % 9 === 0 ? 6 : 2 + (i % 3)}px`);
      star.style.setProperty('--hue', `${(i * 43 + fieldIndex * 31) % 360}deg`);
      star.style.setProperty('--delay', `${-(i % 7)}s`);
      field.appendChild(star);
    }
    const observer = new IntersectionObserver(([entry]) => field.classList.toggle('is-active', entry.isIntersecting), { rootMargin: '100px' });
    observer.observe(field);
  });

  const updatePrice = (form) => {
    const select = form.querySelector('[data-variant-select]');
    const price = form.querySelector('[data-price]');
    if (select && price) price.textContent = select.options[select.selectedIndex]?.dataset.price || price.textContent;
  };

  const updateCustomFields = (form) => {
    const fields = form.querySelector('[data-ninebot-custom-fields],[data-custom-fields]');
    if (!fields) return;
    const selected = form.querySelector('[data-variant-select]')?.selectedOptions?.[0];
    let values = [];
    try { values = JSON.parse(selected?.dataset.options || '[]'); } catch (_) {}
    const manual = /custom/i.test(form.querySelector('[data-custom-property]')?.value || '');
    const custom = manual || values.some((value) => /custom|personal|own design/i.test(String(value)));
    fields.hidden = !custom;
    fields.querySelectorAll('[data-ninebot-required],[data-custom-required]').forEach((input) => { input.required = custom; });
  };

  const productForms = () => each('.product-form', (form) => {
    if (form.dataset.wired) return;
    form.dataset.wired = '1';
    const select = form.querySelector('[data-variant-select]');

    form.querySelectorAll('[data-product-mode-value]').forEach((button) => button.addEventListener('click', () => {
      const group = button.closest('[data-product-mode]');
      const customInput = group.querySelector('[data-custom-product-id]');
      const custom = button.dataset.productModeValue === 'custom';
      group.querySelectorAll('[data-product-mode-value]').forEach((item) => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      if (select) select.disabled = custom;
      if (customInput) { customInput.disabled = !custom; customInput.name = custom ? 'id' : ''; }
      const property = form.querySelector('[data-custom-property]');
      if (property) property.value = custom ? 'Custom design' : 'As shown';
      const price = form.querySelector('[data-price]');
      if (price) price.textContent = custom ? button.dataset.customPrice : select?.selectedOptions?.[0]?.dataset.price || price.textContent;
      updateCustomFields(form);
    }));

    form.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => {
      const group = button.closest('[data-option-group]');
      group.querySelectorAll('[data-option-value]').forEach((item) => {
        item.classList.toggle('is-active', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      const chosen = [...form.querySelectorAll('[data-option-group]')].map((item) => item.querySelector('.is-active')?.dataset.optionValue);
      const match = [...select.options].find((option) => {
        try { return JSON.parse(option.dataset.options || '[]').every((value, index) => value === chosen[index]); } catch (_) { return false; }
      });
      if (match && !match.disabled) {
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }));

    form.querySelectorAll('[data-free-custom-choice] [data-custom-value]').forEach((button) => button.addEventListener('click', () => {
      const choice = button.closest('[data-free-custom-choice]');
      choice.querySelectorAll('[data-custom-value]').forEach((item) => item.classList.toggle('is-active', item === button));
      const property = form.querySelector('[data-custom-property]');
      if (property) property.value = button.dataset.customValue || 'As shown';
      updateCustomFields(form);
    }));

    select?.addEventListener('change', () => { updatePrice(form); updateCustomFields(form); });
    updatePrice(form);
    updateCustomFields(form);
  });

  const reveals = () => {
    const items = document.querySelectorAll('.reveal-item');
    if (!items.length) return;
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .05 });
    items.forEach((item) => {
      if (item.dataset.revealReady) return;
      item.dataset.revealReady = '1';
      observer.observe(item);
    });
  };

  const cartAddons = () => each('[data-add-variant]', (button) => {
    if (button.dataset.wired) return;
    button.dataset.wired = '1';
    button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(button.dataset.addVariant), quantity: 1 }] }) });
        location.reload();
      } catch (_) { button.disabled = false; }
    });
  });

  const init = () => { sparkles(); productForms(); reveals(); cartAddons(); };
  document.addEventListener('DOMContentLoaded', init, { once: true });
  document.addEventListener('shopify:section:load', init);
})();
